import {Scene} from '@babylonjs/core/scene.js';
import {Ray} from '@babylonjs/core/Culling/ray.js';
import {Matrix,Vector3} from '@babylonjs/core/Maths/math.vector.js';
import {MeshBuilder} from '@babylonjs/core/Meshes/meshBuilder.js';
import {StandardMaterial} from '@babylonjs/core/Materials/standardMaterial.js';
import {Color3} from '@babylonjs/core/Maths/math.color.js';
import {Character} from './character';
import {Input} from './input';
import {height} from './world';
import {Planner,Point,clearLine} from './navigation';
export class ClickMove{
 status:'Idle'|'Moving'|'Blocked'|'Arrived'='Idle';reason='';target:Point|null=null;
 private planner:Planner|null=null;private path:Point[]=[];private index=0;private stalled=0;private elapsed=0;private ttl=0;
 private marker;private markerMaterial;
 constructor(private scene:Scene,private canvas:HTMLCanvasElement,private player:Character,private input:Input){
  this.marker=MeshBuilder.CreateTorus('destination-ring',{diameter:1,thickness:.045,tessellation:32},scene);
  this.markerMaterial=new StandardMaterial('destination-gold',scene);this.markerMaterial.diffuseColor=new Color3(.9,.7,.25);this.markerMaterial.emissiveColor=new Color3(.5,.3,.06);this.markerMaterial.alpha=.65;
  this.marker.material=this.markerMaterial;this.marker.isPickable=false;this.marker.setEnabled(false);
  input.onGroundClick=(x,y)=>this.click(x,y);input.onManual=()=>this.cancel();
 }
 cancel(){this.input.autoDirection=null;this.planner=null;this.path=[];this.index=0;this.target=null;this.status='Idle';this.reason='';this.ttl=0;this.marker.setEnabled(false);}
 private reject(reason:string,target:Point|null=this.target){this.cancel();this.target=target;this.status='Blocked';this.reason=reason;}
 private click(x:number,y:number){
  const camera=this.scene.activeCamera;if(!camera)return;
  const engine=this.scene.getEngine(),r=this.canvas.getBoundingClientRect();
  const ray=Ray.CreateNew((x-r.left)*engine.getRenderWidth()/r.width,(y-r.top)*engine.getRenderHeight()/r.height,engine.getRenderWidth(),engine.getRenderHeight(),Matrix.Identity(),camera.getViewMatrix(),camera.getProjectionMatrix());
  const surface=this.scene.pickWithRay(ray,m=>m.isEnabled()&&m.isVisible&&m.visibility>0&&(m.metadata?.terrain===true||m.name.startsWith('road-')));
  const hit=surface?.pickedPoint;
  if(!surface?.hit||!hit||surface.distance>150){this.reject('Нет загруженной поверхности в пределах 150 м',null);return;}
  const solid=this.scene.pickWithRay(ray,m=>m.isEnabled()&&m.isVisible&&m.visibility>0&&/^elmir_(house_residential|central_monument|tree|temple|shop|blacksmith|forge)/.test(m.name));
  if(solid?.hit&&solid.distance<Vector3.Distance(ray.origin,hit)-.03){this.reject('Клик по объекту: '+solid.pickedMesh?.name+' @ '+solid.pickedPoint?.asArray().map(v=>v.toFixed(2)).join(','),null);return;}
  this.select({x:hit.x,z:hit.z});
 }
 select(goal:Point){
  this.cancel();this.target=goal;
  this.planner=new Planner({x:this.player.root.position.x,z:this.player.root.position.z},goal);
  this.reason='Расчёт маршрута';this.elapsed=0;this.stalled=0;
 }
 update(dt:number,yaw:number){
  if(this.ttl>0){this.ttl-=dt;const age=1.2-this.ttl;this.markerMaterial.alpha=.65*Math.min(1,age/.12,this.ttl/.3);this.marker.scaling.setAll(.7+.3*Math.min(1,age/.12)+.15*age/1.2);if(this.ttl<=0)this.marker.setEnabled(false);}
  if(this.planner){
   this.planner.step();if(this.planner.done){
    if(!this.planner.path.length){const reason=this.planner.reason;this.reject(reason);return;}
    this.path=this.planner.path;this.index=0;this.planner=null;this.status='Moving';this.reason='';
    this.marker.position.set(this.target!.x,height(this.target!.x,this.target!.z)+.055,this.target!.z);this.markerMaterial.alpha=0;this.marker.scaling.setAll(.7);this.marker.setEnabled(true);this.ttl=1.2;
   }
  }
  if(this.status!=='Moving')return;
  const p=this.player.root.position;
  while(this.index<this.path.length&&Math.hypot(p.x-this.path[this.index].x,p.z-this.path[this.index].z)<(this.index===this.path.length-1?.12:.02))this.index++;
  if(this.index>=this.path.length){this.status='Arrived';this.path=[];return;}
  const next=this.path[this.index],distance=Math.hypot(next.x-p.x,next.z-p.z);
  if(!clearLine({x:p.x,z:p.z},{x:p.x+(next.x-p.x)*Math.min(1,.4/distance),z:p.z+(next.z-p.z)*Math.min(1,.4/distance)})){this.reject('Маршрут заблокирован');return;}
  const dx=(next.x-p.x)/distance,dz=(next.z-p.z)/distance;
  const run=true,speed=5.5;
  this.input.autoDirection={x:Math.cos(yaw)*dx-Math.sin(yaw)*dz,y:Math.sin(yaw)*dx+Math.cos(yaw)*dz,run,speedScale:Math.min(1,distance/Math.max(.001,speed*dt))};
  this.elapsed+=dt;
  if(this.elapsed>180)this.reject('Превышено время движения');
 }
 afterMove(dt:number,before:Vector3){
  if(this.status!=='Moving')return;
  this.stalled=Vector3.Distance(before,this.player.root.position)<.0001?this.stalled+dt:0;
  if(this.stalled>1.5)this.reject('Нет прогресса у препятствия');
 }
 snapshot(){return {mode:this.status==='Moving'||this.planner?'Click-to-Move':'Manual',status:this.status,target:this.target,points:Math.max(0,this.path.length-this.index),reason:this.reason,planning:Boolean(this.planner)};}
 dispose(){this.cancel();this.marker.dispose();this.markerMaterial.dispose();}
}
